// Notes-app runs in one of two modes, decided by the token's scopes:
//   - "global"   : staff editing the site's public notes (read:notes / write:notes,
//                  or a cookie session with full access).
//   - "personal" : any user editing their OWN private notes (the fixed
//                  "notes:personal" SSO scope).
// The mode drives which API surface the sync engine talks to.

export type NotesMode = "global" | "personal";

const KEY = "notes-app:mode";
const PERSONAL_SCOPE = "notes:personal";

/** Derive the mode from the scopes returned by /api/admin/me/self. */
export function modeFromScopes(scopes: string[] | null): NotesMode {
  // A personal token carries exactly the fixed personal scope. Everything
  // else (global notes token, or a full-access cookie session) is global.
  return scopes !== null && scopes.includes(PERSONAL_SCOPE) ? "personal" : "global";
}

export function setMode(mode: NotesMode): void {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    /* ignore */
  }
}

function getMode(): NotesMode {
  try {
    return localStorage.getItem(KEY) === "personal" ? "personal" : "global";
  } catch {
    return "global";
  }
}

export function isPersonal(): boolean {
  return getMode() === "personal";
}

/** API base path for the current mode. */
export function notesBase(): string {
  return getMode() === "personal" ? "/api/notes-personal" : "/api/admin/notes";
}
